import { Box, Text } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreCustomer } from '@flecto/types'

export type CellNameProps = {
  customer: CoreCustomer
}

export function CellName({ customer }: CellNameProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_customer' })
  return (
    <Box>
      <Text fw={500}>{customer.full_name}</Text>
      {customer.internal && (
        <Text color='dimmed' size='sm'>
          {t('label_internal')}
        </Text>
      )}
    </Box>
  )
}
